var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#879196"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 458,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 458,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814,
    y: 458,
    width: 210,
    height: 458,
    transform: "rotate(-180 814 458)",
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814,
    y: 458,
    width: 200,
    height: 458,
    transform: "rotate(-180 814 458)",
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 498,
    width: 444,
    height: 664,
    rx: 4,
    transform: "rotate(-90 150 498)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.126,
    y: 286,
    width: 554.73,
    height: 116,
    rx: 12,
    fill: "white",
    stroke: "#A1A7AA",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.126,
    y: 91,
    width: 554.73,
    height: 116,
    rx: 12,
    fill: "#EEF0F0",
    stroke: "#A1A7AA",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.616,
    y: 303,
    width: 160.78,
    height: 28,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.226,
    y: 108,
    width: 104.403,
    height: 28,
    fill: "#A1A7AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.616,
    y: 344,
    width: 326.78,
    height: 41,
    fill: "#A1A7AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.226,
    y: 149,
    width: 444.755,
    height: 41,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.226,
    y: 315,
    width: 59.5094,
    height: 57,
    rx: 28.5,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.572,
    width: 484.428,
    height: 64,
    fill: "#424E54"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 814,
    height: 458,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: -10,
    y: -24,
    width: 360,
    height: 501,
    rx: 4,
    fill: "#1D2529"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -7.30005,
    width: 340,
    height: 467.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 64,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26.6667V24H38V26.6667H14ZM14 33.3333H38V30.6667H14V33.3333ZM14 40H38V37.3333H14V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 89,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 95,
    width: 207,
    height: 20,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 22,
    width: 207,
    height: 20,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 149,
    width: 207,
    height: 20,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 203,
    width: 207,
    height: 20,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 365,
    width: 207,
    height: 20,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 419,
    width: 207,
    height: 20,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 257,
    width: 207,
    height: 20,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 311,
    width: 207,
    height: 20,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 143,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 197,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 359,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 413,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.4026c4131d684fee60b94ccc610c50af.svg";
export { ForwardRef as ReactComponent };